// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__168Z7","placeholdersHeader":"styles_placeholdersHeader__1TXLS","editorStyle":"styles_editorStyle__2Xvht","placeholdersBox":"styles_placeholdersBox__EChpW"};